import styled from 'styled-components';
import { TextStyle } from 'components/text';
import { FontSize, FontWeight, device } from 'commons';

export const Wrapper = styled.form`
  width: 100%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.neutral_200};
  border-radius: 8px;
  padding: 16px;
  gap: 16px;
  overflow: hidden;

  @media (max-width: ${device.tablet}px) {
    height: fit-content;
    min-width: unset;
    padding: 16px;
    gap: 0;
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: ${device.tablet}px) {
    padding: 8px 0;
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const CheckboxAndLabel = styled(TitleWrapper)`
  justify-content: flex-start;
`;

export const DriverName = styled.div`
  ${TextStyle} {
    color: ${({ theme }) => theme.primary_300};
    white-space: nowrap;
  }
`;

export const LabelContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Label = styled.label`
  font-size: ${FontSize.font14};
  font-weight: ${FontWeight.bold};
  color: ${({ theme }) => theme.primary_300};
  cursor: pointer;
`;

export const QuantityAndToggleButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const IconButton = styled.div`
  display: flex;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const Consignments = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 8px;

  @media (max-width: ${device.tablet}px) {
    margin: 16px 0;
    gap: 16px;
  }
`;

export const ConsignmentsAccordion = styled.div<{
  $isCardOpen?: boolean;
}>`
  height: 100%;
  display: ${({ $isCardOpen }) => ($isCardOpen ? 'flex' : 'none')};
  flex-direction: column;
  overflow: hidden;
  gap: 16px;
  height: fit-content;

  @media (max-width: ${device.tablet}px) {
    flex-grow: unset;
    overflow-y: hidden;
    transition: height 0.3s;
  }
`;
